import React from "react";

export default function Web_Google_Fonts() {
  return (
    <div>
      <h1>What is Google Fonts</h1>
      <p>
        Route: <code>/web/google-fonts</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
